export default __webpack_public_path__ + "static/media/canvas_blue_tile.8e855b02.jpg";